'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TabsAnatomy as Anatomy } from './Tabs.anatomy';
export const Tabs = ({ orientation, defaultValue, onValueChange, value, content, ...props }) => (_jsxs(Anatomy.Root, { orientation, defaultValue, onValueChange, value, children: [_jsx(Anatomy.List, { ...props }), content] }));
